// extracted by mini-css-extract-plugin
export var activeButton = "calculator-module--activeButton--kh35t";
export var button = "calculator-module--button--h+Uip";
export var buttonGroup = "calculator-module--buttonGroup--0GygA";
export var container = "calculator-module--container--rytCs";
export var disclaimer = "calculator-module--disclaimer--js+ng";
export var disclaimerDesk = "calculator-module--disclaimerDesk--Cvt4V";
export var disclaimerMob = "calculator-module--disclaimerMob--gQS-R";
export var headDescr = "calculator-module--headDescr--hK4RQ";
export var headTitle = "calculator-module--headTitle--e8qlH";
export var section = "calculator-module--section--KgKKJ";
export var termButton = "calculator-module--termButton--jateR";
export var termButtonGroup = "calculator-module--termButtonGroup--GzBPA";
export var termTitle = "calculator-module--termTitle--7SNly";
export var wrapper = "calculator-module--wrapper---bSDJ";